import React from "react";

import {
  Divider,
  Dropdown,
  DropdownList,
  Stack,
  StackItem
} from "@patternfly/react-core";

import AppearanceToggle from "./AppearanceToggle";
import AppearanceSection from "./AppearanceSection";

const AppearanceDropdown = ({
  isOpen,
  toggle,
  close,

  themes,
  colorSchemes,
  contrastModes,

  theme,
  colorScheme,
  contrastMode,

  setTheme,
  setColorScheme,
  setContrastMode,
}) => {
  const selectedColorScheme =
    colorSchemes.find((item) => item.id === colorScheme) ??
    colorSchemes[0];

  return (
    <Dropdown
      isOpen={isOpen}
      onOpenChange={(open) => {
        open ? toggle() : close();
      }}
      popperProps={{
        placement: "bottom-end",
        preventOverflow: true,
      }}
      toggle={(toggleRef) => (
        <AppearanceToggle
          toggleRef={toggleRef}
          isOpen={isOpen}
          toggle={toggle}
          colorScheme={selectedColorScheme}
        />
      )}
    >
      <DropdownList
        style={{
          padding: "1rem",
        }}
      >
        <Stack hasGutter>
          <StackItem>
            <AppearanceSection
                title="Motyw"
                items={themes}
                selected={theme}
                onSelect={setTheme}
            />
          </StackItem>
          <StackItem>
            <Divider />
          </StackItem>
        
          <StackItem>
            <AppearanceSection
                title="Schemat kolorów"
                items={colorSchemes}
                selected={colorScheme}
                onSelect={setColorScheme}
            />
          </StackItem>

          <StackItem>
            <Divider />
          </StackItem>
          <StackItem>
            <AppearanceSection
                title="Kontrast"
                items={contrastModes}
                selected={contrastMode}
                onSelect={setContrastMode}
            />
          </StackItem>
        </Stack>
      </DropdownList>
    </Dropdown>
  );
};

export default AppearanceDropdown;